export default {
  title: 'Log Out',
  description: 'Are you sure you want to log out?',
  buttonCancel: 'Cancel',
  buttonSubmit: 'Log out',
};
